import React from 'react';
import { styled } from '@compiled/react';
import RefreshIcon from '@atlaskit/icon/core/migration/refresh';
import WarningIcon from '@atlaskit/icon/core/migration/warning';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

type Props = {
	onRetry: () => Promise<void>;
};

const ErrorRetry = ({ onRetry }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper>
			<WarnIconWrapper>
				<WarningIcon spacing="spacious" label="" />
			</WarnIconWrapper>
			<BottomWrapper>
				<Message>{formatMessage(messages.unableToLoadData)}</Message>
				<RetryIconWrapper
					role="button"
					data-test-id="software-devops-report-common-error-retry.retry-icon-wrapper"
					onClick={() => onRetry()}
				>
					<RefreshIcon label={formatMessage(messages.retry)} LEGACY_size="small" />
				</RetryIconWrapper>
			</BottomWrapper>
		</Wrapper>
	);
};

export default ErrorRetry;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const RetryIconWrapper = styled.span({
	marginBottom: token('space.negative.025'),
	cursor: 'pointer',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const Message = styled.span({
	color: token('color.text.subtlest'),
	marginRight: token('space.050'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const BottomWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const WarnIconWrapper = styled.div({
	marginBottom: token('space.025'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const Wrapper = styled.div({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	minWidth: '160px',
});
